var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.082 44.9308V58.3948H49.4102V48.1077H56.6717V58.3948H59.8487V31.3154H56.6717V44.9308H46.082Z",
    fill: "#FF4135",
    stroke: "#1B1C1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7668 44.7794L14.7668 58.2435L11.4387 58.2435L11.4387 47.9563L4.17713 47.9563L4.17713 58.2435L1.00022 58.2435L1.00022 31.1641L4.17713 31.1641L4.17713 44.7794L14.7668 44.7794Z",
    fill: "#FF4135",
    stroke: "#1B1C1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6511 0.00012207V57.7897",
    stroke: "#1B1C1F",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5078 57.7898H35.6437M25.5078 58.3949H35.6437M25.5078 59H35.6437",
    stroke: "#82B253",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9637 36.459H17.792V44.6282H43.9637V36.459Z",
    fill: "#F7F2E2",
    stroke: "#1B1C1F",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1436 37.4604H30.969V44.016H43.1436V37.4604Z",
    fill: "#D2D2D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2515 23.9187C43.2863 -10.4166 7.66453 5.0831 1.67001 25.3722C1.39367 26.3074 2.55806 26.9224 3.34154 26.3416C9.9605 21.4354 16.6306 24.7187 19.932 27.721C20.3493 28.1004 20.9949 28.1086 21.4137 27.7308C28.7553 21.1094 36.3388 24.5967 39.9123 27.7524C40.3264 28.118 40.9562 28.126 41.3705 27.7607C46.946 22.8442 52.3977 23.5572 56.1762 25.5348C57.1379 26.0381 58.6852 24.9138 58.2515 23.9187Z",
    fill: "#82B253",
    stroke: "#1B1C1F",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2932 24.5926C52.3416 22.5515 49.6129 22.405 46.1174 23.7158C46.1174 9.61617 39.7671 5.99832 35.9788 5.33265C35.5069 5.27155 35.0301 5.229 34.5488 5.20608C34.9572 5.20332 35.4423 5.23838 35.9788 5.33265C45.7615 6.59922 53.4816 15.8383 56.9055 23.4854C57.3297 24.4326 56.1468 25.1828 55.2932 24.5926Z",
    fill: "#D2D2D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94124 23.1372C13.6899 22.5321 17.7892 23.9205 20.6667 27.1863C21.1963 10.1117 27.9282 6.20265 30.5 4.08337C21.2718 7.4129 15.5053 7.40395 7.94124 23.1372Z",
    fill: "#D2D2D2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.874 27.59C32.9569 22.5761 25.1913 25.2523 21.2231 28.0544C20.5155 28.554 19.4278 28.119 19.4347 27.2529C19.524 16.055 26.526 7.2145 30.2668 4.06121C30.5855 3.79252 31.0389 3.77587 31.3814 4.01344C38.844 9.18861 41.355 20.3874 41.5253 26.8316C41.5475 27.6723 40.555 28.0835 39.874 27.59Z",
    fill: "#F7F2E2",
    stroke: "#1B1C1F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card4.7cc864165c0d1e960b05c2e4b26933b5.svg";
export { ForwardRef as ReactComponent };